import { createContext, useContext } from 'react';

export const TabContext = createContext({
  activeTab: '',
});

export const useTabContext = () => useContext(TabContext);
